import { useEffect, useState } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { Tooltip } from "../../components/utils/Tooltip";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { ContenedorTabla } from "../../components/utils/ContenedorTabla";
import { useProyectos } from "../../../hooks/proyectos/useProyectos";


export const CronogramaProyectos = ({}) => {
    const [ meses, setMeses ] = useState([]);
    const [ anios, setAnios ] = useState([]);
    const [ anioElegido, setAnioElegido ] = useState(new Date().getFullYear());
    const [ mesElegido, setMesElegido ] = useState(new Date().getMonth());
    const [ diasCalendario, setDiasCalendario ] = useState([]);
    const nombreDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
    const classNameSelect = "rounded bg-zinc-800 containerScroll focus:outline-none focus:ring-1 focus:ring-blue-500 h-[30px] ";
    
    const {listarTicketPorMes, calendarioTicket,} = useProyectos()
    const obtenerMeses = async () => {
        setMeses([])
        const formatoMes = new Intl.DateTimeFormat('es-ES', { month: 'long' });
        for (let mes = 0; mes < 12; mes++) {
            const fecha = new Date(anioElegido, mes, 1); // Año 2025, días fijos
            setMeses(prev=> [...prev, formatoMes.format(fecha).charAt(0).toUpperCase() + formatoMes.format(fecha).slice(1)])
        }
    }

    const obtenerAnio = async () => {
        setAnios([])
        for(let anio = 2015; anio <= (new Date().getFullYear() + 1); anio++){
            setAnios(prev => [...prev, anio])
        }
    }

    const generarDias = async () => {
        const primerDiaMes = new Date(anioElegido, mesElegido, 1).getDay(); // Día de la semana (0 = Domingo, 6 = Sábado)
        const diasEnMes = new Date(anioElegido, mesElegido + 1, 0).getDate(); // Total de días en el mes
        const inicioEnLunes = (primerDiaMes + 6) % 7; // Ajustar para que inicie en lunes
        let dia = 1;
        const dias = []

        while(dias.length < 6){
            const semana = {}
            for (let i = 0; i < 7; i++) { // 7 columnas para cada día de la semana
                if (dias.length === 0 && i < inicioEnLunes)
                { 
                    semana[i] = null;
                }
                else if(dia > diasEnMes)
                {
                    semana[i] = null;
                }
                else
                {
                    semana[i] = dia++
                }
            }
            dias.push(semana);
            if (dia > diasEnMes) break;
        }
        setDiasCalendario(dias)
    }

    const cambiarMes = (numeroMes) => {
        let nuevoNumMes = mesElegido + numeroMes
        if(nuevoNumMes >= 0 && nuevoNumMes <= 11){
            setMesElegido(nuevoNumMes)
        }
        else if(numeroMes < 0){
            setMesElegido(11)
            setAnioElegido(anioElegido - 1)
        }
        else{
            setMesElegido(0)
            setAnioElegido(anioElegido + 1)
        }
    }

    
    useEffect(() => {
        obtenerMeses()
        obtenerAnio()
    },[])

    useEffect(() => {
        (async () => {
            await generarDias();
            await listarTicketPorMes(mesElegido,anioElegido);
        })()

    },[anioElegido,mesElegido])


    return (
        <>
            <ContenedorParametros titulo="Cronograma de proyectos"></ContenedorParametros>
            {/* <ContenedorTabla></ContenedorTabla> */}
            <div className="w-full h-[90%] lg:h-[80%] mt-8 overflow-y-auto containerScroll">
            {/* <ContenedorTabla> */}
                <table className="w-full h-full table-fixed">
                    <thead className="bg-zinc-900">
                        <tr key={'nomMes'}>
                            <th colSpan={7} className="text-xl bg-blue-600 text-center p-2">{meses[mesElegido]} {anioElegido}</th>
                        </tr>
                        <tr key={0 + 'nombresDias'}>
                            {
                                nombreDias.map(dia => (
                                    <th className="p-2 border w-1/7">{dia.slice(0,3)}</th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody className="bg-zinc-700">
                        {
                            diasCalendario.map((fecha,j) => (
                                <tr key={j +'_dias'}>
                                    {
                                        nombreDias.map((dia,i) => (
                                            <td
                                                className={`border w-1/7 p-2 ${dia == 'Domingo' ? ' opacity-20 cursor-not-allowed' : ''} overflow-hidden`}
                                                style={{height: `${((1/diasCalendario.length)*100)}% `}}
                                            >
                                                <div className="w-full h-full">
                                                    <p className="text-right">

                                                        <span
                                                            className={`${
                                                                fecha[i] == new Date().getDate() && 
                                                                mesElegido == new Date().getMonth() && 
                                                                anioElegido == new Date().getFullYear() ? 
                                                                ' bg-red-500 rounded-full px-2' : ''} font-bold `}
                                                        >{fecha[i]}</span>
                                                    </p>
                                                    {
                                                        calendarioTicket.length > 0 ?
                                                            calendarioTicket.map(data => {
                                                                if(data.dia == fecha[i]){
                                                                    return(
                                                                        <ul className="overflow-y-auto max-h-[75px] containerScroll">
                                                                            {
                                                                                data.datosPorDia.map(dato => (
                                                                                    <>
                                                                                        <li
                                                                                            className="bg-blue-500 rounded mb-1 px-2 whitespace-nowrap
                                                                                            text-ellipsis overflow-x-hidden"
                                                                                            data-tip={dato.codTicket + '_ticket'}
                                                                                            data-for={dato.codTicket + '_ticket'}
                                                                                        >
                                                                                            [{dato.codTicket}] {dato.nomTicket}
                                                                                        </li>
                                                                                        <Tooltip id={dato.codTicket  + '_ticket'}>{dato.nomTicket}</Tooltip>
                                                                                    </>
                                                                                ))
                                                                            }
                                                                        </ul>
                                                                    )
                                                                }    
                                                            })
    
                                                        : ''
                                                    }
                                                    
                                                </div>
                                            </td>
                                        ))
                                    }
                                </tr>    
                            ))
                        }
                    </tbody>
                    <tfoot className="bg-zinc-900">
                        <tr key={'opcionesElegir'}>
                            <td
                                className="border text-center p-1 bg-blue-600 cursor-pointer"
                                onClick={()=>cambiarMes(-1)}
                            >
                                <i className="fa fa-angle-left text-xl"></i>
                            </td>
                            <td colSpan={5} className="border p-3">
                                <section className="w-full flex gap-3">
                                        <section className="w-[50%] grid grid-cols-[minmax(0,4fr)_minmax(0,6fr)]">
                                        <span >Mes</span>
                                        <select
                                            className={`${classNameSelect}`}
                                            value={mesElegido||0}
                                            onChange={(e) => setMesElegido(Number(e.target.value))}
                                        >
                                            {
                                                meses.length > 0 ? 
                                                    meses.map((mes,i) => (
                                                        <option value={i} key={mes + '_' + i}>{mes}</option>
                                                    ))
                                                : <option value={-1}>No hay opción para mostrar</option>
                                            }
                                        </select>
                                    </section>
                                    <section className="w-[50%] grid grid-cols-[minmax(0,4fr)_minmax(0,6fr)]">
                                        <span>Año</span>
                                        <select
                                            className={`${classNameSelect}`}
                                            value={anioElegido||0}
                                            onChange={(e) => setAnioElegido(Number(e.target.value))}
                                        >
                                            {
                                                anios.length > 0 ? 
                                                    anios.map(anio => (
                                                        <option key={anio + '_anio'} value={anio}>{anio}</option>
                                                    ))
                                                : <option value={-1}>No hay opción para mostrar</option>
                                            }
                                        </select>
                                    </section>
                                </section>
                            </td>
                            <td
                                className="border p-3 text-center bg-blue-600 cursor-pointer"
                                onClick={()=>cambiarMes(+1)}
                            >
                                <i className="fa fa-angle-right text-xl"></i>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            {/* </ContenedorTabla> */}
                {/* <h1 className="text-xl bg-blue-600 p-2 text-center w-full rounded-t">{meses[mesElegido]} {anioElegido}</h1> */}

            </div>
        </>
    )
}